import { Action } from '@weblite/logic-toolkit'
import { useTheme, Popover, PopoverProps } from '@mui/material'
import { useCallback, useEffect, useState } from 'react'
import { useHistoryCustomBack } from 'weblite-router'
import { EmojiPickerBase } from 'weblite-web-emoji'
/* eslint-disable import/no-extraneous-dependencies */
import { emojiI18n } from '$setup/emoji'
import { nothing } from '$helper/functions/utils'
import { editorAPI } from '$comp/_app/components/chat/components/footer/components/send-field/components/text-editor'

export interface EmojiPickerPopoverProps {
  anchorEl: PopoverProps['anchorEl']
  editorId?: string
}

export const showEmojiPickerPopoverAction =
  new Action<EmojiPickerPopoverProps>()

export function EmojiPickerPopover() {
  const [anchorEl, setAnchorEl] = useState<PopoverProps['anchorEl']>(null)
  const [editorId, setEditorId] = useState<string>()
  const theme = useTheme()

  const handleClose = useCallback(() => {
    setAnchorEl(null)
  }, [])

  useEffect(() => {
    return showEmojiPickerPopoverAction.add(
      ({ anchorEl: anchorElement, editorId: editorIdProp }) => {
        setAnchorEl(anchorElement)
        setEditorId(editorIdProp)
      },
    )
  }, [])

  useHistoryCustomBack(handleClose, [handleClose, anchorEl], Boolean(anchorEl))

  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      slotProps={{
        paper: {
          sx: {
            background: 'transparent',
          },
        },
      }}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      role="dialog"
      sx={{
        zIndex: theme.zIndex.modal + 1,
      }}
      onClose={handleClose}
    >
      <div
        style={{
          direction: 'ltr',
        }}
      >
        <EmojiPickerBase
          i18n={emojiI18n}
          onSelect={emoji => editorAPI.insertText(emoji, editorId)}
          onClickAway={nothing}
        />
      </div>
    </Popover>
  )
}
